<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="!!data">
    <InputRadio
        v-model="data"
        :options="optionsPropertyAccess"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        class="radio-options-wide"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";
import { propertyOptions } from "../../../options/propertyOptions";

import QuestionBase from "../../../QuestionBase";
import InputRadio from "../../../inputs/InputRadio";

export default {
  name: 'AccessProvider',
  mixins: [propertyOptions, questionLoadHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title: 'Who should the valuer / surveyor contact to gain access to the property?',
        subTitle: 'This is usually the estate agent in the case of a purchase.',
        tip: `<p>In most cases the surveyor will contact the estate agent to organise a survey or valuation (if an agent is involved).<br><br>In the case of a re-mortgage, they would normally liaise directly with yourself.</p>`
      },
      db: {
        saveLocation: 'mortgage_property_save',
        saveField: 'access',
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>